export function transformToWideFormat(data, groupKey, valueKey) {
	// groupKey: "token_name" or "status"
	// valueKey: "completed_responses" or "total_responses"
	const grouped = {};
  
	data.forEach((item) => {
		const { day } = item;
		const group = item[groupKey];
		const value = item[valueKey] ?? 0;
	
		if (!grouped[day]) grouped[day] = { day };
		grouped[day][group] = value;
	});
  
	// Sort by day for consistent x-axis order
	return Object.values(grouped).sort((a, b) => new Date(a.day) - new Date(b.day));
  
}

// Transform for simple key-value bar charts
export function transformSimpleBarData(data, keyField, valueField) {
	return data.map(item => ({
		name: item[keyField],
		value: item[valueField],
	}));
}
  
  // Transform for grouped / stacked bar charts
export function transformStackedBarData(data, groupKey, categoryKey, valueKey) {
	const grouped = {};

	data.forEach(item => {
		const group = item[groupKey];
		const category = item[categoryKey];
		const value = item[valueKey];

		if (!grouped[group]) grouped[group] = { [groupKey]: group };
		grouped[group][category] = value;
	});

	return Object.values(grouped);
}